import React from 'react'
import PropTypes from 'prop-types'
import Link, { TARGET_BLANK } from 'components/Link'
import Button, { TYPES } from 'components/Button'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'
import { isShop } from 'services/url'
import { MENU_ITEM_ICON_TYPE_ARROW } from './types'

function renderIcon (iconType, iconClassName) {
  switch (iconType) {
    case MENU_ITEM_ICON_TYPE_ARROW:
      return <IconV2 className={iconClassName} type={ICON_TYPES.CHEVRON_DOWN} />
    default: return null
  }
}

const MenuItem = React.memo((props) => {
  const {
    url,
    index,
    label,
    target,
    onClick,
    itemClass,
    linkClass,
    iconType,
    children,
    scrollToTop,
    iconClassName,
  } = props

  const liClasses = itemClass ? `menu-item ${itemClass}` : 'menu-item'
  const linkClasses = linkClass ? `menu-item__link ${linkClass}` : 'menu-item__link'
  const icon = renderIcon(iconType, iconClassName)
  const isShopLink = isShop(url)

  return (
    <li className={liClasses}>
      {
        url
          ? <Link
            to={url}
            scrollToTop={scrollToTop}
            className={linkClasses}
            data-index={index}
            onClick={onClick}
            target={isShopLink ? TARGET_BLANK : target}
            directLink={isShopLink}
          >
            {label}
            {icon || null}
          </Link>
          : <Button
            type={TYPES.LINK}
            className={linkClasses}
            data-index={index}
            onClick={onClick}
          >
            {label}
            {icon || null}
          </Button>
      }
      {children}
    </li>
  )
})

MenuItem.displayName = 'MenuItem'

MenuItem.propTypes = {
  itemClass: PropTypes.string.isRequired,
  linkClass: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
  iconType: PropTypes.string,
  scrollToTop: PropTypes.bool,
  target: PropTypes.string,
  onClick: PropTypes.func,
  url: PropTypes.string,
}

export default MenuItem
